import { connect } from 'react-redux';
import {ROUTES} from '../constants';
import AppFooter from '../components/organisms/AppFooter';

const mapStateToProps = (_,ownProps) => {
	return {
		...ownProps
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onCLickPrivacyPolicy : ()=>{
			dispatch({
				type: ROUTES.PRIVACY_POLICY_PAGE
			});
		},
		onClickTerms : ()=>{
			dispatch({
				type: ROUTES.TERMS_PAGE
			});
		},
	};
};

export default connect(mapStateToProps,mapDispatchToProps)(AppFooter);